import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Divider, MenuItem, Popover, Select } from "@mui/material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { YearCalendar } from "@mui/x-date-pickers/YearCalendar";
import { MonthCalendar } from "@mui/x-date-pickers/MonthCalendar";

function FilterByMonthYear() {
  const [value, setValue] = React.useState("month");
  const [filter, setFilter] = React.useState("Month");

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleChange = (event) => {
    setValue(event.target.value);
    setFilter(event.target.value);
  };
  const handleFilterChange = (event) => {
    setValue(event.target.value);
    setFilter(event.target.value);
  };

  return (
    <div className="relative">
      <div>
        <div className="flex gap-4 items-center ">
          <p className="text-[#98A2B3] font-['inter'] font-[500] text-[12px]">
            Filter by:
          </p>
          <Select
            value={filter}
            onChange={handleFilterChange}
            onClick={handleClick}
            className="w-[190px] h-12 py-3"
            sx={{
              border: "1px solid #DEDEDE",
              borderRadius: "4px",

              "&:focus": {
                outline: "none",
              },
            }}
          >
            <MenuItem style={{ color: "#425466" }} value={"Month"}>
              Month
            </MenuItem>
            <MenuItem style={{ color: "#425466" }} value={"Year"}>
              Year
            </MenuItem>
          </Select>
        </div>
      </div>
      {filter && (
        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            className="mt-8"
          >
            <div className="">
              <div className="rounded-lg flex gap-8 shadow-lg bg-white p-4">
                <div>
                  <FormControl sx={{ fontSize: "12px!important" }}>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={value}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="month"
                        control={<Radio />}
                        label="Month"
                      />
                      <FormControlLabel
                        value="year"
                        control={<Radio />}
                        label="Year"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                <div>
                  <Divider orientation="vertical" />
                </div>

                <div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={[
                        value === "month" ? "MonthCalendar" : "YearCalendar",
                      ]}
                    >
                      {value === "year" && (
                        <DemoItem>
                          <YearCalendar />
                        </DemoItem>
                      )}
                      {value === "month" && (
                        <DemoItem>
                          <MonthCalendar />
                        </DemoItem>
                      )}
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          </Popover>
        </div>
        // <div></div>
      )}
    </div>
  );
}

export default FilterByMonthYear;
